export function ArchiveIcon({ size = 35, className = "", ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      color="white"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M3 7H21M5 7L6 19H18L19 7M9 12H15M12 9V15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}